import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14637",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14637)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-2 0V16.9996H19V0H-2Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-2 0.000149038H4.99985V17H-2V0.000149038Z",
				fill: "#008C45"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0002 0.000149038H19V17H12.0002V0.000149038Z",
				fill: "#D80027"
			})
		]
	})]
});
export default SvgIt;
